{
  "open": "Ouvrir la discussion",
  "unread_one": "{count} message non lu",
  "unread_many": "{count} de messages non lus",
  "unread_other": "{count} messages non lus",
  "close": "Fermer"
}
